import { useEffect, useRef, useState } from "react";
import { Button, Card, Form, Nav, Navbar, Spinner } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useParams, useRouteMatch
} from "react-router-dom";
import { FormControlLabel, FormGroup, Switch as MUISwitch, Typography } from "@material-ui/core";
import { db } from '../../../firebase';
import Day from "./day";


export default function AdminSeason(props) {
    let { id } = useParams()
    let [onDel, setOnDel] = useState(false)
    let [allDays, setallDays] = useState([])
    let [OnAddDay, setOnAddDay] = useState(false)
    let [hideArchive, sethideArchive] = useState(true)

    let nameRef = useRef()
    let dateRef = useRef()

    let daysDBRef = db.collection("seasons").doc(id)
        .collection("days")

    let routeMatch = useRouteMatch()


    // delete this season
    function handleDelete() {
        setOnDel(true)
    }

    function handleCancel() {
        setOnDel(false)
    }

    function handleConfDel() {
        db.collection("seasons").doc(id).delete()
            .then(() => {
                console.log("season document deleted!!!")
                props.reloadSeasons()
                setOnDel(false)
            }).catch((e) => {
                console.log(e)
            })
    }


    // modify matches
    function handleAddDay() {
        setOnAddDay(true)
    }

    function handleCancelAddDay() {
        setOnAddDay(false)
    }

    function handleConfAddDay() {
        if (nameRef.current.value) {
            daysDBRef.add({
                name: nameRef.current.value,
                date: dateRef.current.value,
            })
                .then((docRecord) => {
                    console.log(`Document created with id ${docRecord.id}`)
                    setOnAddDay(false)
                    getallDays()
                })
                .catch((e) => {
                    console.log(e)
                    setOnAddDay(false)
                })
        }
    }

    function handleTottleHideArchive(event) {
        if (event.target.checked) {
            sethideArchive(true)
        }
        else {
            sethideArchive(false)
        }
    }

    function getallDays() {
        daysDBRef.get()
            .then((querySnapshot) => {
                var resallDays = []
                querySnapshot.forEach((doc) => {
                    let matchObj = doc.data()
                    matchObj.id = doc.id
                    resallDays.push(matchObj)
                })
                resallDays = sortDaysByDate(resallDays)
                console.log(resallDays)
                setallDays(resallDays)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    function sortDaysByDate(days) {
        /**
         * Sort sessions based on date, and filter out past sessions 
         */
        var today = new Date();
        var yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        if (hideArchive) {
            days = days.filter((day) => {
                const date = new Date(day.date)
                return date >= yesterday
            })
        }
        days.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date);
        });

        return days
    }

    useEffect(() => {
        getallDays()
    }, [id, hideArchive])

    const displayAllDays = (
        allDays.map((day, ind) => {
            return (
                <div key={ind}>
                    <LinkContainer to={`${routeMatch.url}/days/${day.id}`}>
                        <Nav.Link>
                            <b>{day.name}</b>
                            <br></br>
                            <span>{day.date}</span>
                        </Nav.Link>
                    </LinkContainer>

                </div>
            )
        })
    )

    const displaySeason = (
        <div id="matches-container">
            {onDel ?
                <div>
                    <span>Do you want to delete this season?</span>
                    <Button variant="outline-secondary" onClick={handleCancel}>Cancel</Button>
                    <Button variant="danger" onClick={handleConfDel}>Delete</Button>
                </div>
                : <Button variant="danger" onClick={handleDelete}>Delete this season</Button>}

            <div id="matches-container">
                <Navbar
                    variant="dark"
                    className="navbar"
                >
                    <Nav>
                        <h5 className="light-text">Days</h5>
                        {displayAllDays}
                    </Nav>
                </Navbar>

                {OnAddDay ?
                    <div>
                        <Card>
                            <Card.Body>
                                <Form>
                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" ref={nameRef} placeholder="give this match day a name"></Form.Control>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Date</Form.Label>
                                        <Form.Control type="date" ref={dateRef}></Form.Control>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>

                        <Button variant="light" onClick={handleCancelAddDay}>Cancel</Button>
                        <Button onClick={handleConfAddDay}>Save</Button>
                    </div>
                    :
                    <Button onClick={handleAddDay}>+ add day</Button>
                }
            </div>


        </div>
    )

    return (
        <div>
            {displaySeason}
            <div>
                <Card className="toggle-button center margin-top margin-bottom">
                    <Card.Body>
                        <FormGroup >
                            <FormControlLabel
                                control={
                                    <MUISwitch
                                        checked={hideArchive}
                                        onChange={handleTottleHideArchive}
                                        color="primary"
                                    />
                                }
                                label={hideArchive ? "Hiding Archived Days" : "Showing All Days"}
                            />
                        </FormGroup>
                    </Card.Body>
                </Card>

                <Switch>
                    <Route path={`${routeMatch.url}/days/:id`}>
                        <Day seasonID={id} reloadDays={getallDays} />
                    </Route>
                </Switch>
            </div>
        </div>
    )

}